import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Button,
} from "@chakra-ui/react";
import React, { useEffect, useState, useContext } from "react";
import { AppContext } from "contexts/AppContext";
import InputField from "views/admin/events/components/InputField";
import FileUpload from "views/admin/events/components/FileUpload";

export default function MerchDetailModal({
  isOpen,
  onClose,
  selectedMerch,
  onUpdateMerch,
  onDeleteMerch,
}) {
  const [itemName, setItemName] = useState("");
  const [itemPrice, setItemPrice] = useState("");
  const [itemImage, setItemImage] = useState("");
  const [itemNameError, setItemNameError] = useState("");
  const [itemPriceError, setItemPriceError] = useState("");
  const [uploadError, setUploadError] = useState(null);
  const [fileData, setFileData] = useState(null);

  const { fetchMerchItemData } = useContext(AppContext);

  useEffect(() => {
    if (isOpen) {
      setItemName(selectedMerch?.itemName || "");
      setItemPrice(selectedMerch?.itemPrice || "");
    } else {
      setItemName("");
      setItemPrice("");
      setItemImage("");
      setItemNameError("");
      setItemPriceError("");
      setFileData(null);
    }
  }, [isOpen, selectedMerch]);

  const handleFileSelect = (file) => {
    setFileData(file);
    setItemImage(file);
  };

  const handleFileRemove = () => {
    setFileData(null);
    setItemImage("");
  };

  const handleUpdate = async () => {
    try {
      let isValid = true;

      if (!itemName) {
        setItemNameError("Name is required.");
        isValid = false;
      } else {
        setItemNameError("");
      }

      if (!itemPrice) {
        setItemPriceError("Price is required.");
        isValid = false;
      } else {
        setItemPriceError("");
      }

      if (!isValid) {
        return;
      }

      onUpdateMerch(selectedMerch._id, itemName, itemPrice, fileData);
      fetchMerchItemData();
      onClose();
      setFileData(null);
    } catch (error) {
      console.error("Error updating merch item:", error);
    }
  };

  const handleDelete = async () => {
    onDeleteMerch(selectedMerch._id);
    fetchMerchItemData();
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader flex={1} textAlign="center">
          Merch Item Details
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <InputField
            label="Merch Name"
            type="text"
            value={itemName}
            onChange={(e) => setItemName(e.target.value)}
            errorMessage={itemNameError}
            isRequired={true}
          />
          <InputField
            label="Price"
            type="number"
            value={itemPrice}
            onChange={(e) => setItemPrice(e.target.value)}
            errorMessage={itemPriceError}
            isRequired={true}
          />
          <FileUpload
            error={uploadError}
            setError={setUploadError}
            onFileSelect={handleFileSelect}
            onFileRemove={handleFileRemove}
          />
          <div
            style={{
              display: "flex",
              gap: 20,
              justifyContent: "center",
            }}
          >
            <Button
              fontSize="sm"
              variant="brand"
              fontWeight="500"
              w="30%"
              h="50"
              mb="24px"
              onClick={handleUpdate}
            >
              Update
            </Button>
            <Button
              fontSize="sm"
              variant="brand"
              fontWeight="500"
              w="30%"
              h="50"
              mb="24px"
              style={{ backgroundColor: "red" }}
              onClick={handleDelete}
            >
              Delete
            </Button>
          </div>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
